import { Icon } from '@design-system';
import { cn } from '@utils/cn';
import { useTranslation } from 'next-i18next';

import { Image } from '../../../Image';

const SELECT_FRAMING_IMAGE = '/images/select-framing-option.jpg';

export interface FramingTriggerProps {
  hasError?: boolean;
  onClick: () => void;
}

export const FramingTrigger = ({
  hasError = false,
  onClick,
}: FramingTriggerProps) => {
  const { t } = useTranslation('checkout');

  return (
    <button
      className={cn(
        'flex w-full items-center justify-between gap-3 rounded-sm border text-left transition-colors',
        hasError
          ? 'border-danger-4 text-danger-4'
          : 'border-divider/20 text-neutral-6 hover:border-divider/40',
      )}
      onClick={onClick}
      type="button"
    >
      <span className="p-4">{t('framing.selectOption')}</span>

      <span className="flex shrink-0 items-center gap-3 pr-4">
        <span className="h-[42px] w-24 translate-y-[5px] overflow-hidden">
          <Image
            alt={t('framing.selectOption')}
            className="h-full w-full object-contain"
            src={SELECT_FRAMING_IMAGE}
            width={96}
          />
        </span>
        <Icon name="ic_add" />
      </span>
    </button>
  );
};
